import React from 'react';
import Image, { ImageProps } from '../Image';

/**
 * Props interface for the Avatar component
 * Extends Image props with size property
 */
interface Props extends ImageProps {
	/** Size of the avatar (width and height) in pixels or CSS units */
	size: number | string;
}

/**
 * Avatar component
 * Renders a circular image for user profiles, avatars, etc.
 * Uses the Image component with circular styling
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const Avatar = ({ size, ...props }: Props) => {
	return (
		<Image
			style={{
				width: size,
				height: size,
				borderRadius: '50%',
				verticalAlign: 'middle',
			}}
			{...props}
		/>
	);
};

export default Avatar;
